const menu = [
  'Home', 'About', 
  'Timetable', 'Fees', 'Testimonials', 'Gallery', 'Contact'
]

export default menu